import Vue from 'vue';
import { Servicelayer } from '../../../../../../../src/plugins/servicelayer';
import WidgetEventsApi from '../generated/api/WidgetEvents';
import WidgetEventListResourceViewModel from '../viewModel/resource/WidgetEventListResourceViewModel';
import WidgetEventResourceViewModel from '../viewModel/resource/WidgetEventResourceViewModel';

export default (service: Servicelayer) => ({
  ...WidgetEventsApi(service),

  getEventDetailUrl(model: WidgetEventListResourceViewModel | WidgetEventResourceViewModel) {
    const configPath = Vue.$config.getValueTranslated('widget-tocco-redirect-event-detail', { eventId: model.id!.toString() }) as string;
    return configPath ?? `/_widget/events/detail?eventid=${model.id}`;
  },
  getEventRegisterUrl(model: WidgetEventListResourceViewModel | WidgetEventResourceViewModel) {
    if (model.registrationFormUrl) {
      return model.registrationFormUrl;
    }
    const configPath = Vue.$config.getValueTranslated('widget-tocco-redirect-event-register', { eventId: model.id!.toString() }) as string;
    return configPath ?? `/_widget/events/register?eventid=${model.id}`;
  },
  getEventSearchUrl() {
    const configPath = Vue.$config.getValueTranslated('widget-tocco-redirect-event-search', {}) as string;
    return configPath ?? '/_widget/events';
  },

});
